import * as type from './selfPromotionActionTypes';

export const fetchPendingSelfPromotions = () => ({
  type: type.FETCH_PENDING_SELF_PROMOTIONS,
});

export const setPendingSelfPromotions = (pending) => ({
  type: type.SET_PENDING_SELF_PROMOTIONS,
  pending,
});

export const setPendingSelfPromotionsLoading = (loading) => ({
  type: type.SET_PENDING_SELF_PROMOTIONS_LOADING,
  loading,
});

export const setPendingSelfPromotionsError = (error) => ({
  type: type.SET_PENDING_SELF_PROMOTIONS_ERROR,
  error,
});

export const answerSelfPromotion = (configId, cycleId, rank, answer) => ({
  type: type.ANSWER_SELF_PROMOTION,
  configId,
  cycleId,
  rank,
  answer,
});

export const setAnsweringSelfPromotion = (answering) => ({
  type: type.SET_ANSWERING_SELF_PROMOTION,
  answering,
});

export const setAnswerSelfPromotionError = (error) => ({
  type: type.SET_ANSWER_SELF_PROMOTION_ERROR,
  error,
});

export const removePendingSelfPromotion = (configId) => ({
  type: type.REMOVE_PENDING_SELF_PROMOTION,
  configId,
});
